export default __webpack_public_path__ + "static/media/p1050317.4f895a99-min.0e369026.jpg";